import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createAppointment,
  fetchAppointments,
  setAppointmentStatus,
} from "../../redux/slices";
import Toast from "../../Hooks/useToast";

const useAppointmentController = () => {
  const dispatch = useDispatch();
  const { list, loading, creating, statusUpdating } = useSelector(
    (state) => state.appointment
  );

  useEffect(() => {
    dispatch(fetchAppointments());
  }, [dispatch]);

  const refetchAppointments = useCallback(() => {
    dispatch(fetchAppointments());
  }, [dispatch]);

  const handleCreateAppointment = useCallback(
    async (payload) => {
      console.log(payload,'papapapappapa');
      try {
        await dispatch(createAppointment(payload)).unwrap();
        Toast("Appointment created successfully", "success");
      } catch (err) {
        const msg =
          err?.body?.message ??
          err?.data?.message ??
          err?.message ??
          "Failed to create appointment";
        Toast(msg, "error");
        throw err;
      }
    },
    [dispatch]
  );

  const handleSetAppointmentStatus = useCallback(
    async (id, status) => {
      try {
        await dispatch(setAppointmentStatus({ id, status })).unwrap();
        Toast(
          `Appointment marked as ${status}`,
          "success"
        );
      } catch (err) {
        const msg =
          err?.body?.message ??
          err?.data?.message ??
          err?.message ??
          "Failed to update status";
        Toast(msg, "error");
        throw err;
      }
    },
    [dispatch]
  );

  return {
    values: {
      list,
      loading,
      creating,
      statusUpdating,
    },
    functions: {
      refetchAppointments,
      handleCreateAppointment,
      handleSetAppointmentStatus,
    },
  };
};

export default useAppointmentController;
